import { useQuery } from '@tanstack/react-query';
import { api } from '../client';
import { queryKeys } from '../queryKeys';
import type { CurrentUserResponse } from '../types';

/** GET /api/me (F-19 AppBar-Nutzermenü). */
export function useMe() {
  return useQuery({
    queryKey: queryKeys.me(),
    queryFn: () => api.get<CurrentUserResponse>('/api/me'),
    staleTime: Infinity,
  });
}
